<template>
  <div class="card mb-25 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter un produit</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="produitForm" @submit="addProduit" :keep-values="valuess" :validation-schema="produitSchema">
        <div class="row gx-1">
          <div class="col-md-12">
            <div class="row row gx-2">
              <div class="col-md-2">
                <!--<div class="form-check">
                  <label for="estActif" class="form-check-label fw-medium position-relative top-1">
                    Est Service ?
                  </label>
                  <input id="estService" name="estService" v-model="estService" :value="estService" type="checkbox"
                    class="form-check-input shadow-none" />
                  <ErrorMessage name="estService" class="text-danger" />
                </div>-->
                <label class="d-block text-black fw-semibold mb-1">
                  Image Produit
                </label>
                <div class="upload-container">
                  <input type="file" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                    accept="image/jpeg, image/png, image/jpg" hidden />
                  <!-- Carte d'aperçu (cliquable pour choisir une image) -->
                  <div class="preview-card" @click="triggerFileInput">
                    <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                    <div v-else class="text-center">
                      <div>
                        <i class="icofont icofont-camera fs-1"></i>
                      </div>
                      Cliquez pour ajouter l'image principal du produit
                    </div>
                    <!-- Bouton de suppression sur l'image -->
                    <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage"><i
                        class="icofont icofont-close"></i></button>
                  </div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="row gx-1">
                  <div class="col-md-2">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Code du produit
                      </label>
                      <Field type="text" name="code" class="form-control shadow-none fs-md-15 text-black"
                        readonly="true" placeholder="Ce code est généré" />
                      <ErrorMessage name="code" class="text-danger" />
                    </div>
                  </div>
                  <!--<div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Référence usine du produit
                      </label>
                      <Field name="refProd" type="text" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer la référence" />
                      <ErrorMessage name="refProd" class="text-danger" />
                    </div>
                  </div>-->
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                       Catégorie du produit<span class="text-danger">*</span>
                      </label>
                      <Field name="famille" v-slot="{ field }">
                        <Multiselect :options="familleOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" 
                          placeholder="Sélectionner la catégorie" />
                      </Field>
                      <ErrorMessage name="famille" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-sm-2 mb-md-2" ref="dropdownRef">
                      <label class="d-block text-black fw-semibold mb-1">
                        Nom du Produit<span class="text-danger">*</span>
                      </label>
                      <Field name="nomProd" type="text" v-model="prodName" @focus="showBox = true"
                        class="mb-2 form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer le nom du produit" />
                      <ul class="dropdown-menu show" v-if="produitOptions.length > 0 && showBox == true">
                        <li v-for="(produit, index) in produitOptions" :key="index">
                          <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                            produit.nomProd }}</a>
                        </li>
                      </ul>
                      <ErrorMessage name="nomProd" class="text-danger" />
                    </div>
                  </div>
                  <!--<div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3" ref="dropdownRef1">
                      <label class="d-block text-black fw-semibold mb-1">
                        Nom Standar du produit
                      </label>
                      <Field name="nomStandar" type="text" v-model="prodNameS" @focus="showBoxStan = true"
                        class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom" />
                      <ul class="dropdown-menu show " v-if="produitStanOptions.length > 0 && showBoxStan == true">
                        <li v-for="(produit, index) in produitStanOptions" :key="index">
                          <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                            produit.nomProd }}</a>
                        </li>
                      </ul>
                      <ErrorMessage name="nomStandar" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3" ref="dropdownRef2">
                      <label class="d-block text-black fw-semibold mb-1">
                        Nom marché du produit
                      </label>
                      <Field name="nomMarche" type="text" v-model="prodNameM" @focus="showBoxM = true"
                        class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom marché" />
                      <ul class="dropdown-menu show " v-if="produitMarOptions.length > 0 && showBoxM == true">
                        <li v-for="(produit, index) in produitMarOptions" :key="index">
                          <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                            produit.nomProd }}</a>
                        </li>
                      </ul>
                      <ErrorMessage name="nomMarche" class="text-danger" />
                    </div>
                  </div>-->

                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Unité de Stockage
                      </label>
                      <Field name="uniteStock" v-slot="{ field }" v-model="uniteStock">
                        <Multiselect :options="conditionnementOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" placeholder="Choisir l'unité de stockage" />
                      </Field>
                      <ErrorMessage name="uniteStock" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Unité de gestion
                      </label>
                      <Field name="uniteGestion" v-slot="{ field }" v-model="uniteGestion">
                        <Multiselect :options="conditionnementgOptions" :searchable="true" track-by="label"
                          label="label" v-model="field.value" v-bind="field" @select="seletUniteGestion(field.value)"
                          placeholder="Choisir l'unité de gestion" />
                      </Field>
                      <ErrorMessage name="uniteGestion" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Groupe de Taxe<span class="text-danger">*</span>
                      </label>
                      <Field name="groupe" v-model="groupe" v-slot="{ field }">
                        <Multiselect :options="groupeOptions" :searchable="true" track-by="value" label="label"
                          v-model="groupe" v-bind="field" placeholder="Sélectionner un groupe"
                          @select="onGroupeSelect" />
                      </Field>
                      <ErrorMessage name="groupe" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Mode de définition<span class="text-danger">*</span>
                      </label>
                      <Field name="mode" v-model="mode" :readonly="estRedonly" v-slot="{ field }">
                        <Multiselect :options="modeOptions" :searchable="true" track-by="value" label="label"
                          v-model="mode" :disabled="estRedonly" placeholder="Sélectionner le mode de definition"
                          @select="(val) => { mode = val }" />

                      </Field>
                      <ErrorMessage name="mode" class="text-danger" />
                    </div>
                  </div>
                   <div class="col-md-12">
                  <div class="form-group mb-3 mb-sm-3 mb-md-3">
                    <label class="d-block text-black fw-semibold mb-1">
                      Description du produit
                    </label>
                    <Field name="descProd" as="textarea" placeholder="Entrer la description" v-slot="{ field }"
                      class="form-control shadow-none rounded-0 text-black">
                      <textarea class="form-control shadow-none rounded-0 text-black" v-model="field.value"></textarea>
                    </Field>
                    <ErrorMessage name="descProd" class="text-danger" />
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-1">
                Méthode de Suivi de stock <span class="text-danger">*</span>
              </label>
              <Field name="suiviStock" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="['CUMP', 'FIFO', 'LIFO', 'Par lot']" v-model="field.value"
                  v-bind="field" placeholder="Sélectionner la méthode" />
              </Field>
              <ErrorMessage name="suiviStock" class="text-danger" />
            </div>
          </div>-->




         
          
          <div class="col-md-12 mb-md-25">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane"
                  type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">
                  Conditionnement
                </button>
              </li>
             
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                <div class="row">
                  <div class="border border-primary mb-1">
                    <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                      style="background-color: #0a59a4">
                      <div class="col-md-7">
                        <h3 class="fs-4 text-white">
                          Conditionnement(s) du produit
                        </h3>
                      </div>
                      <div class="col-md-5">
                        <div class="d-flex float-end">
                          <button
                            class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                            type="button" :class="{ 'cursor-not-allowed': isDisable }" :disabled="isDisable"
                            @click="addRowConditionnement()">
                            <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                            Ajouter un conditionnement
                          </button>
                          <router-link to="/liste-mouvements"></router-link>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="row gx-1 ">
                        <div class="col-md-2">
                          <label class="d-block text-black fw-semibold">
                            Conditionnement
                            <span class="text-danger">*</span>
                          </label>
                        </div>
                        <div class="col-md-2">
                          <label class="d-block text-black fw-semibold mb-1">
                            Quantité <span class="text-danger">*</span>
                          </label>
                        </div>
                        <div class="col-md-2">
                          <label class="d-block text-black fw-semibold mb-1">
                            Prix Min <span class="text-danger">*</span>
                          </label>
                        </div>
                        <div class="col-md-2">
                          <label class="d-block text-black fw-semibold mb-1">
                            PrixDeVente <span class="text-danger">*</span>
                          </label>
                        </div>
                        <div class="col-md-2">
                          <label class="d-block text-black fw-semibold mb-1">
                            Prix Max <span class="text-danger">*</span>
                          </label>
                        </div>


                        <div class="col-md-2">
                          <label class="d-block text-black fw-semibold mb-1">
                            Action
                          </label>
                        </div>
                      </div>
                      <hr class="mt-0" />
                      <div class="row gx-1" v-for="(conditionnement, index) in conditionnements" :key="index">
                        <div class="col-md-2 mb-3">
                          <div class="">
                            <input v-if="index == 0" type="text" readonly :value="uniteGestion?.split('|')[2]"
                              class="form-control shadow-none fs-md-15 text-black" />
                            <Multiselect v-else :options="conditionnementOptions" :searchable="true" track-by="label"
                              label="label" v-model="conditionnement.conditionnement" placeholder="Sélectionner"
                              @select="selectConditionnement(conditionnement.conditionnement, conditionnement)" />
                            <div class="invalid-feedback" v-if="valideteRowProduit(conditionnement.conditionnement)">
                              Le conditionnement est obligatoire.
                            </div>
                          </div>
                        </div>

                        <div class="col-md-2 mb-3">
                          <div class="form-group mb-2 ">
                            <input v-if="index == 0" type="text" readonly v-model="conditionnement.quantite"
                              class="form-control shadow-none fs-md-15 text-black" />
                            <div class="input-group" v-else>
                              <input type="number" v-model="conditionnement.quantite" :class="valideteRowProduit(conditionnement.quantite)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black '" placeholder="Entrer la quantité"
                                aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                              <span class="input-group-text" id="inputGroup-sizing-default">{{ uniteGestion != null
                                ? (uniteGestion?.split("|")[2]) : 'UM' }}</span>
                            </div>
                            <div v-if="valideteRowProduit(conditionnement.quantite)" class="invalid-feedback">
                              La quantité est obligatoire.
                            </div>
                          </div>
                        </div>

                        <div class="col-md-2 mb-3">
                          <div class="form-group mb-2 ">
                            <input v-if="index == 0" type="text" v-model="conditionnement.prixMin"
                              class="form-control shadow-none fs-md-15 text-black" />
                            <div class="input-group" v-else>
                              <input type="number" v-model="conditionnement.prixMin" :class="isPrixMaxInvalid(conditionnement)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                : 'form-control shadow-none fs-md-15 text-black'"
                                placeholder="Entrer le prix minimal" aria-label="Saisir le prix minimal"
                                aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div v-if="isPrixMinInvalid(conditionnement)" class="invalid-feedback">
                              Le prix minimal doit être inférieur ou égal au prix de vente.
                            </div>
                            <div v-if="valideteRowProduit(conditionnement.prixMin)" class="invalid-feedback">
                              Le prix minimal est obligatoire.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 mb-3">
                          <div class="form-group mb-2 ">
                            <input v-if="index == 0" type="text" v-model="conditionnement.prixVente"
                              @input="calculePrix(conditionnement.prixVente, conditionnement)"
                              class="form-control shadow-none fs-md-15 text-black" />
                            <div class="input-group" v-else>
                              <input type="number" v-model="conditionnement.prixVente"
                                @input="calculePrix(conditionnement.prixVente, conditionnement)" :class="valideteRowProduit(conditionnement.prixVente)

                                  ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                  : 'form-control shadow-none fs-md-15 text-black '"
                                placeholder="Entrer le prix de vente" aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm" />

                            </div>
                            <div v-if="valideteRowProduit(conditionnement.prixVente)" class="invalid-feedback">
                              Le prix de vente est obligatoire.
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 mb-3">
                          <div class="form-group mb-2 ">
                            <input v-if="index == 0" type="text" v-model="conditionnement.prixMax"
                              class="form-control shadow-none fs-md-15 text-black" />
                            <div class="input-group" v-else>
                              <input type="number" v-model="conditionnement.prixMax" :class="isPrixMaxInvalid(conditionnement)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                : 'form-control shadow-none fs-md-15 text-black '" placeholder="Entrer le prix maximal"
                                aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                            </div>
                            <div v-if="isPrixMaxInvalid(conditionnement)" class="invalid-feedback">
                              Le prix Max doit être supérieur ou égal au prix de vente
                            </div>
                            <div v-if="valideteRowProduit(conditionnement.prixMax)" class="invalid-feedback">
                              Le prix maximal est obligatoire.
                            </div>
                          </div>
                        </div>
                       
                        <div class="col-md-2 mb-3" v-if="index > 0">
                          <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                            @click="removeRowConditionnement(index)">
                            <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3 text-dark" type="submit" :disabled="(isDisable || isDisableCha) ? true : false"
                :class="(!isDisable || !isDisableCha) ? { 'cursor-not-allowed': false } : { 'cursor-not-allowed': true }">
                Ajouter un produit
              </button>
              <router-link to="/produits/liste-produits" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive, onBeforeUnmount } from "vue";
import { Form, Field, ErrorMessage, useFieldArray } from "vee-validate";
import { error, success } from "@/utils/utils";
import { useRouter, useRoute } from "vue-router";

import ApiService from "@/services/ApiService";
import { Produit } from "@/models/Produit";
import * as Yup from "yup";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import DropZone from "dropzone-vue";


export default defineComponent({
  name: "AddProduit",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    DropZone
  },
  setup: () => {
    const produitForm = ref<Produit | null>(null);
    const router = useRouter();
    const route = useRoute();
    const familleOptions = ref([]);
    const groupeTaxeOptions = ref([]);
    const famille = ref();
   
    const modeDefPrixOptions = ref([]);
    const produitStanOptions = ref([]);
    const produitMarOptions = ref([]);
    const prodName = ref("");
    const prodNameS = ref("");
    const prodNameM = ref("");
    //const magasinOptions = ref([]);
    const methodeOptions = ref([]);
    //const estService = ref(false);
    const isDisableCha = ref(false);
    const defaultImage = 'path/to/your/default-image.jpg'; // Chemin de l'image par défaut
    const hasFiles = ref(false); // Indicateur pour savoir si des fichiers ont été déposés
    const toutFichier = ref<Array<File>>([])
    const conditionnementOptions = ref([]);
    const conditionnementgOptions = ref([]);
    const produitOptions = ref([]);
    
    const prixProd = ref();
    const produitsss: any = ref(null);
    const valuess = ref();
    const showBox = ref(false);
    const showBoxM = ref(false);
    const showBoxStan = ref(false);
   
    const codeProduit = ref("");
    const uniteStock = ref(null);
    const groupeOptions = ref([]);
    const estRedonly = ref(true);
    const modeOptions = ref([
      { value: 'HT', label: 'HT' },
      { value: 'TTC', label: 'TTC' },
    ]);

    const mode = ref('');
    const groupe = ref('');




    const dropzoneOptions = {
      url: 'your-upload-url', // URL de téléchargement des fichiers
      thumbnailWidth: 150,
      maxFilesize: 2,
      headers: { "My-Awesome-Header": "header value" }
    };

    const onSuccess = (file) => {
      hasFiles.value = true; // Mettre à jour l'indicateur lorsqu'un fichier est déposé avec succès
    };

    const onError = (file, message) => {
      console.error('File upload error:', message);
    };

    // watch(estService, () => {
    //   console.log('estservice', estService.value)
    // })

    watch(prodName, (newValue, oldValue) => {
      if (newValue != "" && newValue.length >= 3) {
        fetchProduis(newValue);
      } else {
        produitOptions.value = [];
      }
    })

    watch(prodNameS, (newValue, oldValue) => {
      if (newValue != "" && newValue.length >= 3) {
        fetchSProduis(newValue);
      } else {
        produitStanOptions.value = [];
      }
    })

    watch(prodNameM, (newValue, oldValue) => {
      if (newValue != "" && newValue.length >= 3) {
        fetchMProduis(newValue);
      } else {
        produitMarOptions.value = [];
      }
    })


    const montantTotal = ref(0);
    const isDisable = ref(true);
    const isDisablee = ref(true);
    const conditionnements = reactive([]);

    const images = reactive([
      {
        file: null,
        previewUrl: null,
      },
    ]);

    const addRowConditionnement = () => {
      conditionnements.push({
        conditionnement: "",
        quantite: 0,
        prixMin: null,
        prixVente: null,
        prixMax: null,
        conditionnement2: ""
      });
    };

    const onFileAdd = (file: any) => {
      toutFichier.value.push(file["file"]);
    };

    const onFileRemove = (file: File) => {
      //
      console.log("J'ai retiré ceci ==> ", file);
      console.log("LLLL ==> ", file["file"].name);
      console.log("TOUS FICHIERS ==> ", toutFichier.value);
      // Recherche de l'index du fichier dans le tableau
      const index = toutFichier.value.findIndex(fil => ((fil.name === file["file"].name) && (fil.size === file["file"].size) && (fil.type === file["file"].type)));
      if (index !== -1) {
        toutFichier.value.splice(index, 1);
      } else {
        console.log(`Le fichier ${file["file"].name} n'a pas été trouvé dans le tableau.`);
      }
    }

    const dropdownRef = ref(null);
    const dropdownRef1 = ref(null);
    const dropdownRef2 = ref(null);

    function handleClickOutside(event) {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        showBox.value = false;
      }

      if (dropdownRef1.value && !dropdownRef1.value.contains(event.target)) {
        showBoxStan.value = false;
      }

      if (dropdownRef2.value && !dropdownRef2.value.contains(event.target)) {
        showBoxM.value = false;
      }
    }

    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };

    function getProduit(id: number) {
      ApiService.get("/produits/" + id.toString())
        .then(({ data }) => {
          console.log(data.data, "datadatadatadatadatadatadatadata");
          for (const key in data.data) {
            produitForm.value?.setFieldValue(key, (typeof data.data[key] === 'object' && data.data[key] !== null) ? data.data[key].id : data.data[key]);
          }
          produitForm.value?.setFieldValue("famille", data.data["famille"].id)
          console.log("famille ===> ", data.data["famille"])
          famille.value = parseInt(data.data["famille"].id);
          //uniteGestion.value = parseInt(data.data["uniteGestion"].id);
          //uniteStock.value = parseInt(data.data["uniteStock"].id);
          produitForm.value?.setFieldValue("uniteStock", data.data["uniteStock"].id + "|" + data.data["uniteStock"].valeur + "|" + data.data["uniteStock"].libelle);
          produitForm.value?.setFieldValue("uniteGestion", data.data["uniteGestion"].id + "|" + data.data["uniteGestion"].valeur + "|" + data.data["uniteGestion"].libelle);
          produitForm.value?.setFieldValue("codeProduit", "");
          produitForm.value?.setFieldValue("id", null);
          produitForm.value?.setFieldValue("imagePrincipal", null);
          delete produitForm.value?.id;
        
          
          if (data.data["produitconditionnements"] != null) {
            data.data["produitconditionnements"].forEach(element => {
              conditionnements.push({
                conditionnement: element.conditionnement.id + "|" + element.conditionnement.valeur + "|" + element.conditionnement.libelle,
                quantite: element.qteCond,
                conditionnement2: element.conditionnement2.id + "|" + element.conditionnement2.valeur + "|" + element.conditionnement2.libelle,
              });
            });

          }

          console.log("FOOROROROROROMMM ===> ", famille.value)
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }


    const addRowImage = () => {
      images.push({
        file: null,
        previewUrl: null,
      });
    };

    const removeRowConditionnement = (index) => {
      if (conditionnements.length > 1) conditionnements.splice(index, 1);
      //totals();
    };

    const removeRowImage = (index) => {
      if (images.length > 1) images.splice(index, 1);
      //totals();
    };

    const valideteRowProduit = (e) => {
      if (e == "" || e == 0 || e == "" || e == "0" || e == null || e < 0) {
        return true;
      } else {
        return false;
      }
    };

    const isPrixMinInvalid = (conditionnement => {
      if (conditionnement.prixMin != null && conditionnement.prixVente != null) {
        return conditionnement.prixMin > conditionnement.prixVente;
      }
      return false;
    })

    const isPrixMaxInvalid = (conditionnement => {
      if (conditionnement.prixMax != null && conditionnement.prixVente != null) {
        return conditionnement.prixMax < conditionnement.prixVente;
      }
      return false;
    })

    const modeDefPrix = ref("");
    const selectGroupe = (value) => {
      console.log(value, "valuevaluevaluevalue");
      if (parseInt(value.split("|")[1]) > 0) {
        modeDefPrix.value = "TTC(Toutes Taxes Comprises)";
      } else {
        modeDefPrix.value = "HT(Hors Taxes)";
      }
    }


    //  const calculePrix = (prix: number,produit:any) => {
    //   const taux = groupe.value.split('|')[2];
    //   console.log("valllll",taux);


    //   let prixHT = prix;
    //   let prixTTC = prix;

    //   if(mode.value === 'HT' ) {
    //     prixHT = prix;
    //     prixTTC = prixHT * (1 + parseInt(taux) / 100);
    //   } else if (mode.value === 'TTC') {
    //     prixTTC = prix;
    //     prixHT = prixTTC / (1 + parseInt(taux) / 100);
    //   }

    //   produit.prixHT =prixHT,
    //   produit.prixTTC =prixTTC
    //   console.log("calcul",produit);
    // };


    const calculePrix = (prix: number, produit: any) => {
      const taux = groupe.value.split('|')[2];
      const code = groupe.value.split('|')[1];

      let prixHT = prix;
      let prixTTC = prix;

      if (code === 'D') {
        prixHT = prix;
        prixTTC = prixHT * (1 + parseInt(taux) / 100);
      } else if (mode.value === 'HT') {
        prixHT = prix;
        prixTTC = prixHT * (1 + parseInt(taux) / 100);
      } else if (mode.value === 'TTC') {
        prixTTC = prix;
        prixHT = prixTTC / (1 + parseInt(taux) / 100);
      }

      produit.prixHT = prixHT;
      produit.prixTTC = prixTTC;
    };

   

    watch(conditionnements, (newValue, oldValue) => {
      let isInvalid = false;
      Object.keys(newValue).forEach(function (key) {
        if (
          valideteRowProduit(newValue[key].conditionnement) ||
          valideteRowProduit(newValue[key].quantite) ||
          valideteRowProduit(newValue[key].prixVente) ||
          valideteRowProduit(newValue[key].prixMin) ||
          valideteRowProduit(newValue[key].prixMax)
        ) {
          isInvalid = true;
        } else if (
          newValue[key].prixMin != null &&
          newValue[key].prixVente != null &&
          parseFloat(newValue[key].prixMin) > parseFloat(newValue[key].prixVente)
        ) {
          isInvalid = true;
        } else if (
          newValue[key].prixMax != null &&
          newValue[key].prixVente != null &&
          parseFloat(newValue[key].prixMax) < parseFloat(newValue[key].prixVente)
        ) {
          isInvalid = true;
        } else {
        }
      });
      isDisable.value = isInvalid;
    });


   

    watch(images, (newValue, oldValue) => {
      Object.keys(newValue).forEach(function (key) {
        if (newValue[key].image == "") {
          isDisablee.value = true;
        } else {
          isDisablee.value = false;
        }
      });
    });


    const { remove, push, fields, update } = useFieldArray("conditionnements");



    const fetchConditionnements = async () => {
      try {
        const response = await axios.get("/conditionnements");
        const conditionnementsData = response.data.data;
        produitsss.value = conditionnementsData;
        conditionnementOptions.value = conditionnementsData.map((conditionnement) => ({
          value: conditionnement.id + "|" + conditionnement.valeur + "|" + conditionnement.libelle,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchConditionnementugs = async () => {
      try {
        const response = await axios.get("/conditionnementugs");
        const conditionnementgData = response.data.data;
        produitsss.value = conditionnementgData;
        conditionnementgOptions.value = conditionnementgData.map((conditionnement) => ({
          value: conditionnement.id + "|" + conditionnement.valeur + "|" + conditionnement.libelle,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

   

    const fetchProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=0`);
        console.log(response, "responseresponseresponseresponse");
        produitOptions.value = response.data.data;;
      } catch (error) {
        //
      }
    };

    const fetchSProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=1`);
        console.log(response, "responseresponseresponseresponse");
        produitStanOptions.value = response.data.data;;
      } catch (error) {
        //
      }
    };

    const fetchMProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=2`);
        console.log(response, "responseresponseresponseresponse");
        produitMarOptions.value = response.data.data;;
      } catch (error) {
        //
      }
    };

    const pays = [
      "Afghanistan",
      "Afrique du Sud",
      "Albanie",
      "Algérie",
      "Allemagne",
      "Andorre",
      "Angola",
      "Anguilla",
      "Antarctique",
      "Antigua-et-Barbuda",
      "Antilles Néerlandaises",
      "Arabie Saoudite",
      "Argentine",
      "Arménie",
      "Aruba",
      "Australie",
      "Autriche",
      "Azerbaïdjan",
      "Bahamas",
      "Bahreïn",
      "Bangladesh",
      "Barbade",
      "Bélarus",
      "Belgique",
      "Belize",
      "Bénin",
      "Bermudes",
      "Bhoutan",
      "Bolivie",
      "Bosnie-Herzégovine",
      "Botswana",
      "Brésil",
      "Brunéi Darussalam",
      "Bulgarie",
      "Burkina Faso",
      "Burundi",
      "Cambodge",
      "Cameroun",
      "Canada",
      "Cap-vert",
      "Chili",
      "Chine",
      "Chypre",
      "Colombie",
      "Comores",
      "Costa Rica",
      "Côte d'Ivoire",
      "Croatie",
      "Cuba",
      "Danemark",
      "Djibouti",
      "Dominique",
      "Égypte",
      "El Salvador",
      "Émirats Arabes Unis",
      "Équateur",
      "Érythrée",
      "Espagne",
      "Estonie",
      "États Fédérés de Micronésie",
      "États-Unis",
      "Éthiopie",
      "Fédération de Russie",
      "Fidji",
      "Finlande",
      "France",
      "Gabon",
      "Gambie",
      "Géorgie",
      "Géorgie du Sud et les Îles Sandwich du Sud",
      "Ghana",
      "Gibraltar",
      "Grèce",
      "Grenade",
      "Groenland",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guinée",
      "Guinée Équatoriale",
      "Guinée-Bissau",
      "Guyana",
      "Guyane Française",
      "Haïti",
      "Honduras",
      "Hong-Kong",
      "Hongrie",
      "Île Bouvet",
      "Île Christmas",
      "Île de Man",
      "Île Norfolk",
      "Îles (Malvinas) Falkland",
      "Îles Åland",
      "Îles Caïmanes",
      "Îles Cocos (Keeling)",
      "Îles Cook",
      "Îles Féroé",
      "Îles Heard et McDonald",
      "Îles Mariannes du Nord",
      "Îles Marshall",
      "Îles Mineures Éloignées des États-Unis",
      "Îles Salomon",
      "Îles Turks et Caïques",
      "Îles Vierges Britanniques",
      "Îles Vierges des États-Unis",
      "Inde",
      "Indonésie",
      "Irak",
      "Irlande",
      "Islande",
      "Israël",
      "Italie",
      "Jamahiriya Arabe Libyenne",
      "Jamaïque",
      "Japon",
      "Jordanie",
      "Kazakhstan",
      "Kenya",
      "Kirghizistan",
      "Kiribati",
      "Koweït",
      "L'ex-République Yougoslave de Macédoine",
      "Lesotho",
      "Lettonie",
      "Liban",
      "Libéria",
      "Liechtenstein",
      "Lituanie",
      "Luxembourg",
      "Macao",
      "Madagascar",
      "Malaisie",
      "Malawi",
      "Maldives",
      "Mali",
      "Malte",
      "Maroc",
      "Martinique",
      "Maurice",
      "Mauritanie",
      "Mayotte",
      "Mexique",
      "Monaco",
      "Mongolie",
      "Montserrat",
      "Mozambique",
      "Myanmar",
      "Namibie",
      "Nauru",
      "Népal",
      "Nicaragua",
      "Niger",
      "Nigéria",
      "Niué",
      "Norvège",
      "Nouvelle-Calédonie",
      "Nouvelle-Zélande",
      "Oman",
      "Ouganda",
      "Ouzbékistan",
      "Pakistan",
      "Palaos",
      "Panama",
      "Papouasie-Nouvelle-Guinée",
      "Paraguay",
      "Pays-Bas",
      "Pérou",
      "Philippines",
      "Pitcairn",
      "Pologne",
      "Polynésie Française",
      "Porto Rico",
      "Portugal",
      "Qatar",
      "République Arabe Syrienne",
      "République Centrafricaine",
      "République de Corée",
      "République de Moldova",
      "République Démocratique du Congo",
      "République Démocratique Populaire Lao",
      "République Dominicaine",
      "République du Congo",
      "République Islamique d'Iran",
      "République Populaire Démocratique de Corée",
      "République Tchèque",
      "République-Unie de Tanzanie",
      "Réunion",
      "Roumanie",
      "Royaume-Uni",
      "Rwanda",
      "Sahara Occidental",
      "Saint-Kitts-et-Nevis",
      "Saint-Marin",
      "Saint-Pierre-et-Miquelon",
      "Saint-Siège (État de la Cité du Vatican)",
      "Saint-Vincent-et-les Grenadines",
      "Sainte-Hélène",
      "Sainte-Lucie",
      "Samoa",
      "Samoa Américaines",
      "Sao Tomé-et-Principe",
      "Sénégal",
      "Serbie-et-Monténégro",
      "Seychelles",
      "Sierra Leone",
      "Singapour",
      "Slovaquie",
      "Slovénie",
      "Somalie",
      "Soudan",
      "Sri Lanka",
      "Suède",
      "Suisse",
      "Suriname",
      "Svalbard et Île Jan Mayen",
      "Swaziland",
      "Tadjikistan",
      "Taïwan",
      "Tchad",
      "Terres Australes Françaises",
      "Territoire Britannique de l'Océan Indien",
      "Territoire Palestinien Occupé",
      "Thaïlande",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinité-et-Tobago",
      "Tunisie",
      "Turkménistan",
      "Turquie",
      "Tuvalu",
      "Ukraine",
      "Uruguay",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Wallis et Futuna",
      "Yémen",
      "Zambie",
      "Zimbabwe"
    ];

    const selectConditionnement = async (value: any, conditionnement: any) => {
      console.log("Element", value);
      console.log("Objet", conditionnement.quantite);
      conditionnement.quantite = value.split("|")[1];
    };

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const addProduit = async (values, { resetForm }) => {
      console.log('Valeurs du formulaire :', values);
      console.log('Iff')
      values.conditionnements = conditionnements.map(conditionnement => ({
        conditionnement: conditionnement.conditionnement.split("|")[0],
        qteCond: conditionnement.quantite,
        prixMin: conditionnement.prixMin,
        prixVente: conditionnement.prixVente,
        prixMax: conditionnement.prixMax,
        conditionnement2: uniteGestion.value.split("|")[0],
        prixVenteTtc: conditionnement.prixTTC,
        prixVenteHt: conditionnement.prixHT,

      }));
      console.log("tkttt", values.conditionnements);
      values["uniteGestion"] = uniteGestion.value.split("|")[0]
      values["uniteStock"] = uniteStock.value.split("|")[0]
      values["groupe"] = groupe.value.split("|")[0];

      if (imageFile.value) {
        console.log(imageFile.value, "imageFile.value")
        values["imagePrincipal"] = imageFile.value;
      }


      //values['images'] =  images.map(image => (image.file))
      // retirer urmImage du values
      delete values.urlImage;
      if (toutFichier.value.length > 0) {
        values['autreFichier[]'] = [];
        values['autreFichier[]'] = toutFichier.value.map((fichier) => (fichier));
      }

      console.log('Les fichiers ===> ', values["images"]);
      console.log('Mon FORMIULAIRE', values);

      ApiService.postWithFile("/produits", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeProduit" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const fetchFamille = async () => {
      try {
        const response = await ApiService.get("all/all/familles");
        const familleData = response.data.data.data;
        console.log(familleData, "familleData");
        familleOptions.value = familleData.map((famille) => ({
          value: famille.id,
          label: `${famille.codeFamille} - ${famille.libelleFamille} ${famille.famille ? '(' + famille.famille.libelleFamille + ')' : ""}`,
        }));
      } catch (error) {
        //
      }
    };




    const fetchGroupeTaxe = async () => {
      try {
        const response = await ApiService.get("/all/groupeTaxes");
        const groupeData = response.data.data.data;
        groupeOptions.value = groupeData.map((groupe) => ({
          value: `${groupe.id}|${groupe.code}|${groupe.taux}`,
          label: `${groupe.code} - ${groupe.libelle}`,
        }));
      } catch (error) {
        error('Erreur lors du chargement des groupes');
      }
    };

    const produitSchema = Yup.object().shape({

      nomProd: Yup.string().required("Le nom est obligatoire"),

      imagePrincipal: Yup.string().notRequired(),
      famille: Yup.string().required("La famille est obligatoire"),
      uniteGestion: Yup.string().notRequired(),
      uniteStock: Yup.string().notRequired(),

      descProd: Yup.string().notRequired(),
      mode: Yup.string().required('Le mode de définition est obligatoire').oneOf(['HT', 'TTC'], 'Le mode doit être HT ou TTC'),
      groupe: Yup.string().required('Le groupe est obligatoire'),
    });



    const onGroupeSelect = (selectedGroupe: any) => {
      groupe.value = selectedGroupe;
      const code = selectedGroupe.split('|')[1];
      if (code == 'B' || code == 'D') {
        estRedonly.value = false;
        mode.value = 'TTC';
        produitForm.value?.setFieldValue('mode', 'TTC');
      } else {
        estRedonly.value = true;
        mode.value = 'HT';
        produitForm.value?.setFieldValue('mode', 'HT');
      }
      produitForm.value?.setFieldValue('groupe', selectedGroupe)
    };


    const seletUniteGestion = (valeur) => {
      uniteGestion.value = valeur;
      conditionnements.length = 0;
      conditionnements.push({
        conditionnement: uniteGestion.value.split("|")[0],
        quantite: uniteGestion.value.split("|")[1],
        prixMin: null,
        prixVente: null,
        prixMax: null,
        conditionnement2: ""
      });
    }

    const uniteGestion = ref(null);
    const fileInput = ref(null);
    const imagePreview = ref(null);
    const imageFile = ref<File>(null);

    const triggerFileInput = () => {
      fileInput.value.click();
    };

    const onFilePrinChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    };

    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
    };

    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await fetchFamille();
      await fetchGroupeTaxe();
      await fetchConditionnements();
      await fetchConditionnementugs();

      if (route.params.id) {
        console.log("ID from route params:", route.params.id);
        await getProduit(parseInt(route.params.id as string));
      }
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      seletUniteGestion,
      produitOptions,
      uniteGestion,
      produitStanOptions,
      produitMarOptions,
      prodName,
      prodNameS,
      prodNameM,
      addProduit,
      hasFiles,
      produitForm,
      familleOptions,
      modeDefPrixOptions,
      groupeTaxeOptions,
      methodeOptions,
      // magasinOptions,
      conditionnements,
      conditionnementgOptions,
      addRowImage,
      removeRowImage,
      removeRowConditionnement,
      addRowConditionnement,
      valideteRowProduit,
      isPrixMaxInvalid,
      isPrixMinInvalid,
      montantTotal,
      valuess,
      modeDefPrix,
      selectGroupe,
      images,
      conditionnementOptions,
      prixProd,
      selectConditionnement,
      isDisable,
      isDisablee,
      getCurrentDate,
      isDisableCha,
      //estService,
      onFileChange,
      dropzoneOptions,
      onFileAdd,
      onFileRemove,
      onSuccess,
      onError,
      defaultImage,
      produitSchema,
      triggerFileInput,
      onFilePrinChange,
      removeImage,
      imagePreview,
      imageFile,
      fileInput,
      uniteStock,
     pays,
      showBox, showBoxM, showBoxStan, dropdownRef, dropdownRef1, dropdownRef2
      , groupeOptions, mode, onGroupeSelect, estRedonly, modeOptions, calculePrix

    };
  },
});
</script>

<style scoped>
.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 200px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>
